// Seskupení chatů v menu jako v Claude: Dnes, Včera, jednotlivé dny posledního týdne, Starší.
import type { ConversationDTO } from '@sam/shared';

export interface ChatGroup {
  key: string;
  label: string;
  items: ConversationDTO[];
}

const dayStart = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
const DAY = 86_400_000;
const WEEKDAY = ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'];

/** Nepřipnuté chaty podle poslední aktivity (updatedAt), nejnovější nahoře. */
export function groupChats(convs: ConversationDTO[], now = new Date()): ChatGroup[] {
  const today = dayStart(now);
  const groups: ChatGroup[] = [];
  const push = (key: string, label: string, c: ConversationDTO) => {
    const last = groups[groups.length - 1];
    if (last?.key === key) last.items.push(c);
    else groups.push({ key, label, items: [c] });
  };
  const sorted = [...convs].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  for (const c of sorted) {
    const d = new Date(c.updatedAt);
    const diff = Math.round((today - dayStart(d)) / DAY);
    if (diff <= 0) push('today', 'Dnes', c);
    else if (diff === 1) push('yesterday', 'Včera', c);
    else if (diff < 7) push(`d${diff}`, `${WEEKDAY[d.getDay()][0].toUpperCase()}${WEEKDAY[d.getDay()].slice(1)} ${d.getDate()}. ${d.getMonth() + 1}.`, c);
    else push('older', 'Starší', c);
  }
  return groups;
}
